import GradientContainer from "@app/components/gradient/gradient-container";

const EquippedSectionHeader = () => {
  return (
    <div className="grid items-center gap-y-4 w-full md:w-[440px] text-center">
      <span className="mobile-h3 md:h3 text-background-primary-dark">
        Equipped to compete
      </span>
      <GradientContainer overrideClassName="mx-auto">
        <div className="h-2 w-40" />
      </GradientContainer>
      <span className="subheading text-text-color-mid-em">
        Hit the ground running
      </span>
    </div>
  );
};

export default EquippedSectionHeader;
